<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Demographics and Contact Information EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="tglnId"
              disabled
              label="TGLN ID"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="firstName"
              disabled
              label="First Name"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="middleName"
              disabled
              label="Middle Name"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="lastName"
              disabled
              label="Last Name"
              class="mandatory-field"
            />
          </div>
        </div>



        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="birthDate"
              disabled
              label="Date of Birth"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="gender"
              disabled
              label="Sex"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="isGenderDifferent"
              disabled
              label="Gender is different"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="genderDifferent"
              disabled
              label="Gender"
            />
          </div>
        </div>

        <div class="row">
           <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="genderOther"
              disabled
              label="Gender-Other"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="insuranceType"
              disabled
              label="Insurance Type"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="insuranceNumber"
              disabled
              label="Insurance Number"
            />
          </div>

          <div
            v-if="insuranceType === 'OOP'"
            class="col-2"
          >
            <ADSTextInput
              id="disabled-text"
              v-model="insuranceProvince"
              disabled
              label="Insurance Province"
            />
          </div>
        </div>
  

        <!-- <div class="row">
          <div class="col-5">
            <ADSTextInput
              v-model="className"
              class="CoverageClassName"
              disabled
              label="Coverage Class Name"
            />
          </div>
        </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="address"
              disabled
              label="Address"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="city"
              disabled
              label="City"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="state"
              disabled
              label="Province/State"
              class="mandatory-field"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="postalCode"
              disabled
              label="Postal Code"
              class="mandatory-field"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="country"
              disabled
              label="Country"
              class="mandatory-field"
            />
          </div>

          <!-- <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="age"
              disabled
              label="Age"
            />
          </div> -->

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="mobile"
              disabled
              label="Mobile"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="homeNumber"
              disabled
              label="Home Number"
            />
          </div>
        </div>
    

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="email"
              disabled
              label="Email"
              class="Email"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="ethnicity"
              disabled
              label="Ethnicity"
              class="mandatory-field"
            />
          </div>

          <div class="col-2" v-if="ethnicity === 'Other'">
            <ADSTextInput
              id="disabled-text"
              v-model="ethnicityOther"
              disabled
              label="Ethnicity Other"
            />
          </div>
        </div>

        <div
          v-if="patientType === 'Recipient'"
          class="row"
        >
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="bloodType"
              disabled
              label="Blood Type"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="rhFactor"
              disabled
              label="RH Factor"
              class="mandatory-field"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="bloodTypeVerified"
              disabled
              label="Blood Type Verified"
            />
          </div> 
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import { PATIENT_TYPES } from '@/constants';
// import { ADSTextInput } from '@afflo/afflo-design-system';
import _ from 'lodash';

export default {
  name: "DemographicsSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      tglnId : this.getTglnId( this.patient ),
      firstName : this.getName( this.patient ).firstName,
      lastName : this.getName( this.patient ).lastName,
      middleName : this.getName( this.patient ).middleName,
      birthDate: this.patient.birthDate,
      gender: this.patient.gender,
      isGenderDifferent: this.getIsGenderDifferent( this.patientBundle ),
      genderDifferent: this.getGenderDifferent( this.patientBundle ),
      genderOther: this.getGenderOther( this.patientBundle ),
      country: this.getCountry( this.patient ),
      age: this.calculateAge( this.patient.birthDate ),
      state: this.patient.address[ 0 ]?.state,
      postalCode: this.patient.address[ 0 ]?.postalCode,
      address: this.patient.address[ 0 ]?.line?.[ 0 ],
      city: this.patient.address[ 0 ]?.city,
      mobile: this.getMobile( this.patient ),
      homeNumber: this.getHomeNumber( this.patient ),
      email: this.getEmail( this.patient ),
      pager: this.getPager( this.patient ),
      ethnicity: this.getEthnicity( this.patientBundle ),
      ethnicityOther: this.getEthnicityOther( this.patientBundle ),
      insuranceType: this.getInsuranceType( this.patientBundle ),
      insuranceNumber: this.getInsuranceNumber( this.patientBundle ),
      insuranceProvince: this.getInsuranceProvince( this.patientBundle ),
      className: this.getClassName( this.patientBundle ),
      bloodType: this.getBloodType( this.patientBundle ),
      rhFactor: this.getRHFactor( this.patientBundle ),
      bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
      //cPRA: this.getCPRA( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    calculateAge( birthDate ) {
      let age = Math.floor( ( new Date() - new Date( birthDate ) ) / 31536000000 );
      return age?.toString();
    },
    getTglnId( patient ) {
      let identifier_type="TGLNRecipient"; // By default, it was already recipient, so keeping it as that for now.
      switch( this.patientType ){
        case PATIENT_TYPES.DONOR.name:
          identifier_type = "TGLNDonor";
          break;
        case PATIENT_TYPES.RECIPIENT.name:
          identifier_type = "TGLNRecipient";
          break;
      }
      let tglnId = patient.identifier.filter( ( n ) => ( n.use === 'usual' && n.type?.text === identifier_type ) ) ;
      return tglnId[0]?.value ? tglnId[0]?.value : '--' ;
    },
    getName( patient ) {
      let fullName = patient.name.filter( ( n ) => ( n.use === 'official' ) ) ;
      let firstName = '';
      let lastName = '';
      let middleName = '';
      if( fullName[0] && fullName[0].given && fullName[0].family ) {
        lastName = _.get( fullName[0], 'family', '' );
        firstName = _.get( fullName[0], 'given.[0]', '' ); 
        middleName = _.get( fullName[0], 'given.[1]', '' ); 
      }
      let name = { 'firstName': firstName, "lastName": lastName, "middleName": middleName };
      return name;
    },
    getCountry( patient ) {
      if( patient.address[ 0 ]?.country === 'CAN' ) {
        return 'CAN';
      } else if( patient.address[ 0 ]?.country === 'USA' ) {
        return 'USA';
      } else if( patient.address[ 0 ]?.country === 'US' ) {
        return 'USA';
      }
      else if( patient.address[ 0 ]?.country === 'CA' ) {
        return 'CAN';
      } else {
        return patient.address[ 0 ]?.country;
      }
    },
    getMobile( patient ) {
      let mobile = patient.telecom?.filter( ( n ) => ( n.use === 'mobile' ) ) ;
      if( mobile ) {
        const value = String( _.get( mobile[ 0 ], 'value', '' ) );
        return value.replace( /^\s*(?:\+1)\s*[-.]?\s*/, '' );
      } 
      return ' ';
      // return _.get( mobile[ 0 ], 'value', 'r' ); 
    },
    getHomeNumber( patient ) {
      let home = patient.telecom?.filter( ( n ) => ( n.use === 'home' ) ) ;
      if( home && home[0] && home[0].value ) {
        const value = String( home[0].value );
        return value.replace( /^\s*(?:\+1|1)\s*[-.]?\s*/, '' );
      }   
      return ' '; 
    },
    getEmail( patient ) {
      let email = patient.telecom?.filter( ( n ) => ( n.system === 'email' ) ) ;
      if( email && email[0] && email[0].value ) {
        return email[0].value;
      }   
    },
    getPager( patient ) {
      let pager = patient.telecom?.filter( ( n ) => ( n.system === 'pager' ) ) ;
      if( pager && pager[0] && pager[0].value ) {
        return pager[0].value;
      }   
    },
    getEthnicity( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7924' ) ) ;
      if( ethnicity && ethnicity[ 0 ] ) {
        return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
      } 
      }
    },
    getEthnicityOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7925' ) ) ;
      if( ethnicity && ethnicity[ 0 ] ) {
        return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
      } 
      }
    },
    getIsGenderDifferent( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let genderDifferent = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7926' ) ) ;
      if( genderDifferent && genderDifferent[ 0 ] ) {
        return _.get( genderDifferent[ 0 ], 'resource.component[0].valueBoolean', 'Unchecked' ) === true ? 'true' : 'false';
      } 
      return 'false';
      }
    },
    getGenderDifferent( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let genderOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7927' ) ) ;
      if( genderOther && genderOther[ 0 ] ) {
        return _.get( genderOther[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getGenderOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let genderOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7928' ) ) ;
      if( genderOther && genderOther[ 0 ] ) {
        return _.get( genderOther[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getInsuranceType( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        let type = _.get( coverages[ 0 ][ 0 ], 'resource.payor[0].display' );
        if( type === 'OHCN' ) {
          return 'OHIP';
        } else if( [ 'Quebec', 'Alberta', 'BC', 'BRITISH COLUMBIA', 'NB', 'NEW BRUNSWICK', 'PEI', 'PRINCE EDWARD ISLAND', 'REFHP', 'UHIP',
        'MAN', 'MANITOBA', 'NS', 'NOVA SCOTIA', 'NFLD', 'NEWFOUNDLAND', 'NWT', 'NORTH WEST TERRITORIES', 'NU', 'NUNAVUT', 'SASK', 'SASKATCHEWAN', 'YUK', 'YUKON' ].some( ( p ) => p.toLowerCase() === type?.toLowerCase() ) ) {
          return 'OOP';
        } else if( type?.startsWith( 'SK' ) ) {
          return 'Private';
        } else {
          return 'Other';
        }
      }
    },
    getInsuranceNumber( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return _.get( coverages[ 0 ][ 0 ], 'resource.subscriberId' );
     }
    },
    getInsuranceProvince( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        if( this.getInsuranceType( patientBundle ) === 'OHIP' ){
          return 'n/a'
        }
        if( this.getInsuranceType( patientBundle ) === 'Private' ){
          return 'n/a'
        }
        if( this.getInsuranceType( patientBundle ) === 'OOC' ){
          return 'n/a'
        }
        if( this.getInsuranceType( patientBundle ) === 'Other' ){
          return 'n/a'
        }
        return _.get( coverages[ 0 ][ 0 ], 'resource.contained[0].contact[0].address.state' );
     }
     return 'n/a';
    },
    getClassName( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Coverage' && n[ 0 ].resource?.status === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return coverages[ 0 ][ 0 ].resource?.class[ 0 ]?.name;
      }
    },
    getBloodType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let bloodType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7929' ) ) ;
      if( bloodType && bloodType[ 0 ] ) {
        return _.get( bloodType[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getRHFactor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let rhFactor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7930' ) ) ;
      if( rhFactor && rhFactor[ 0 ] ) {
        return _.get( rhFactor[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getBloodTypeVerified( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let bloodTypeVerified = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'SK#7931' ) ) ;
      if( bloodTypeVerified && bloodTypeVerified[ 0 ] ) {
        return _.get( bloodTypeVerified[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ; 
      } 
      }
    },
    // getCPRA( patientBundle ) {
    //   let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[ 0 ], 'resource.resourceType' ) === 'Observation' ) );
    //   if( observation && observation[ 0 ] ) {
    //   let cpra = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#135' ) ) ; 
    //   if( cpra && cpra[0 ]?.resource.code.text ) {
    //     return _.get( cpra[0], 'resource.component[0].valueString' );  
    //   }   
    // }
    // },
  },
};
</script>

<style scoped>

/* .card {
  height: 750px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 780px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
  padding-bottom: 10px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
width: 200px;
/* padding-left: 50px; */
}

.inputDisplayCovergage {
border-style: solid;
width: 320px;
background-color: #F2F2F2;
}

.inputDisplayCustom {
border-style: solid;
width: 200px;
border-color: rgb(185, 184, 234);
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.mandatory-field label::after) {
  content: " *";
  color: red;
}

:deep(.CoverageClassName .afflo-ds-form-control) {
  width: 360px;
}

:deep(.Email .afflo-ds-form-control) {
  width: 280px;
}

</style>
